'use strict';

module.exports = function (x, y, obj) {
  var objt = {};

  if (x || y) {
    var tt = [x || 0].concat(y ? [y] : []);
    objt = {
      transform: 'translate(' + tt.join(',') + ')'
    };
  }

  obj = typeof obj === 'object' ? obj : {};
  return Object.assign(objt, obj);
};